import {message} from 'antd';

export function getDisableLabels(course) {
  const today = new Date().toLocaleDateString('sv');
  const resp = [];

  // if (today < course.open_date) {
  //   resp.push('報名尚未開始');
  // }
  // if (today >= course.close_date) {
  //   resp.push('報名已截止');
  // }
  // if (course.reg_cnt >= course.max_reg_cnt) {
  //   resp.push('報名已額滿');
  // }

  return resp;
}

export const routes = {
  doctor: {
    categories: [
      {
        name: '行事曆',
        url: '/doctor/events/index',
      },
      {
        name: '福利活動',
        url: '/doctor/events/events' + `?cat=福利活動`,
      },
      {
        name: '活動花絮',
        url: `/doctor/events/gallery`,
      },
      {
        name: '課程活動',
        url: '/doctor/events/events',
      },
      {
        name: '線上報名',
        url: '/doctor/events/events?reg_online=true',
      },
      {
        name: '線上問卷',
        url: '/doctor/events/question',
      },
      {
        name: '線上學習',
        url: '/doctor/events/learning',
      },
    ],
  },
  people: {
    categories: [
      {
        name: '行事曆',
        url: '/people/events/index',
      },
      {
        name: '活動快訊',
        url: '/people/events/events',
      },
      {
        name: '活動花絮',
        url: `/people/events/gallery`,
      },
    ],
  },
};
